import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Polygon from "ol/geom/Polygon";
import Point from "ol/geom/Point";
import MultiPoint from "ol/geom/MultiPoint";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

import { calculateCenter } from "lib/utilities/feature";

export default function RasterFeatureStyle(feature:Feature<Geometry>) {
	const rasterFeatureStyle:Style = new Style({
		geometry: (feature:Feature<Geometry>) => feature.get("modifyGeometry")?.geometry || feature.getGeometry(),
		fill: new Fill({
			color: "rgba(255, 255, 255, 0.2)"
		}),
		stroke: new Stroke({
			color: "blue",
			width: 3,
			lineDash: [5, 5]
		}),
		image: new CircleStyle({
			radius: 7,
			fill: new Fill({
				color: "blue"
			}),
		})
	});
	
	const styles:Style[] = [rasterFeatureStyle];
	const result:any = calculateCenter(feature.getGeometry());
	
	if(result.center) {
		styles.push(
			new Style({
				geometry: new Point(result.center),
				image: new CircleStyle({
					radius: 4,
					fill: new Fill({
						color: "red"
					})
				})
			})
		);
	}
	
	return styles;
}